import { IS_DEV } from "@/utils/env";

/** Set false to match the signed-in viewer instead of {@link OPPORTUNITIES_REPRESENTATIVE_OVERRIDE}. */
export const OPPORTUNITIES_REPRESENTATIVE_OVERRIDE_ENABLED = true;

/**
 * Match identity for representative sort / border / logs when
 * {@link OPPORTUNITIES_REPRESENTATIVE_OVERRIDE_ENABLED} is true.
 */

const override_for_dev = {
  userId: "67b448552b7408bc84f67547dda3f51d35264c438ef003d48fb18a76669a7a85",
  email: "nathan+realtor-17th@cai3p0.com",
};

const override_for_prod = {
  userId: "8d9a0cb8220743a2844cae2d987119be73b3f288a82c8700eca24005a44520d6",
  email: "connor@gentryaz.com",
};

export const OPPORTUNITIES_REPRESENTATIVE_OVERRIDE = IS_DEV ? override_for_dev : override_for_prod;
